// extracted by mini-css-extract-plugin
export var Link = "Link-module--Link--3Npoj";
export var red = "Link-module--red--1md_u";
export var green = "Link-module--green--3v-Lz";
export var blue = "Link-module--blue--1SsEa";